import { EMPTY_LIST } from '../../../../constants/common'

export const EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING = 'building'

export const EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT = 'flat'

export const EMAIL_COPY_TO_ENTITY_FILTER_MODAL_INITIAL_VALUES = {
  [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING]: EMPTY_LIST,
  [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT]: EMPTY_LIST,
}
